/**
 * 根据当前服务端请求路径设置 thinkType Cookie
 * - 以 /inperson 开头：设置 thinkType=inperson
 * - 否则：如果未设置，则默认设置 thinkType=online
 */
import Cookies from 'js-cookie'

export default function ({ req, route, store }) {
  // Server-side: use Koa ctx cookies
  if (process.server) {
    const ctx = req && req.ctx ? req.ctx : null
    if (!ctx || !ctx.cookies) return

    const path = ctx.path || ''
    const { cookies } = ctx

    console.log('path is ', path)
    if (path.startsWith('/inperson')) {
      console.log('set thinkType to inperson')
      ctx.state = ctx.state || {}
      ctx.state.thinkType = 'inperson'
      cookies.set('thinkType', 'inperson', { httpOnly: false, overwrite: true })
      if (store && store.commit) store.commit('SET_THINK_TYPE', 'inperson')
      return
    }

    if (path === '/') {
      console.log('set thinkType to online')
      ctx.state = ctx.state || {}
      ctx.state.thinkType = 'online'
      cookies.set('thinkType', 'online', { httpOnly: false, overwrite: true })
      if (store && store.commit) store.commit('SET_THINK_TYPE', 'online')
      return
    }

    const current = cookies.get('thinkType') || ''
    console.log('current is ', current)
    if (!current) {
      ctx.state = ctx.state || {}
      ctx.state.thinkType = 'online'
      cookies.set('thinkType', 'online', { httpOnly: false, overwrite: true })
      if (store && store.commit) store.commit('SET_THINK_TYPE', 'online')
    } else {
      ctx.state = ctx.state || {}
      ctx.state.thinkType = current
      cookies.set('thinkType', current, { httpOnly: false, overwrite: true })
      if (store && store.commit) store.commit('SET_THINK_TYPE', current)
    }
    return
  }

  // Client-side: update cookie on SPA navigations
  try {
    const path = (route && route.path) || (typeof window !== 'undefined' ? window.location.pathname : '') || ''
    if (path.startsWith('/inperson')) {
      Cookies.set('thinkType', 'inperson', { path: '/' })
      if (store && store.commit) store.commit('SET_THINK_TYPE', 'inperson')
    } else if (path === '/') {
      Cookies.set('thinkType', 'online', { path: '/' })
      if (store && store.commit) store.commit('SET_THINK_TYPE', 'online')
    } else if (!Cookies.get('thinkType')) {
      Cookies.set('thinkType', 'online', { path: '/' })
      if (store && store.commit) store.commit('SET_THINK_TYPE', 'online')
    } else {
      const value = Cookies.get('thinkType') || ''
      if (store && store.commit) store.commit('SET_THINK_TYPE', value)
    }
  } catch (e) {
    // ignore
  }
}
